import { useEffect, useState } from 'react';
import { fetchAvailableSeatOptions } from './requestSeatApi';
export const useRequestSeatModalData = () => {
  const [requestSeatModalData, setRequestSeatModalData] = useState({
    availableSeatOptions: [],
    defaultSeat: null,
    isLoading: true
  });
  useEffect(() => {
    fetchAvailableSeatOptions().then(availableSeatOptions => {
      setRequestSeatModalData({
        isLoading: false,
        availableSeatOptions,
        defaultSeat: availableSeatOptions[0] ? availableSeatOptions[0].value : null
      });
    }).catch(() => {
      setRequestSeatModalData({
        availableSeatOptions: [],
        defaultSeat: null,
        isLoading: false
      });
    });
  }, []);
  return requestSeatModalData;
};